module.exports = __webpack_public_path__ + "static/media/trailer.1899644b.svg";